import React, { useState, useEffect, useCallback } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { LoanApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';

export const BfiNumberSearch = ({ loanTypeId, onSelect }) => {
    let CACHE = {};
    const PER_PAGE = 20;

    const styles = {
        searchResult: { lineHeight: '25px' },
    };

    const loanApi = new LoanApi.LoanApi(applicationInsights);

    //Bfi Search
    const [searchText, set_searchText] = useState('');
    const [isLoading, set_isLoading] = useState(false);
    const [results, set_results] = useState([]);
    const [bfiQuery, set_bfiQuery] = useState('');

    useEffect(() => {
        CACHE = {};
    }, [loanTypeId]);

    const searchBfiNumbers = async (typeId, query, page = 1) => {
        return await loanApi.searchBfiNumbers(typeId, query, page, PER_PAGE);
    };

    const handleBfiInputChange = (q) => {
        q = (q ?? '').toLowerCase();
        set_bfiQuery(q);
    };

    const handleBfiSearch = useCallback(
        (q) => {
            q = (q ?? '').toLowerCase();
            if (CACHE[q]) {
                set_results(CACHE[q].options);
                return;
            }

            set_isLoading(true);
            searchBfiNumbers(loanTypeId, q).then((resp) => {
                CACHE[q] = { options: resp.result, page: 1 };
                set_isLoading(false);
                set_results(resp.result);
            });
        },
        [loanTypeId]
    );

    const handleBfiPagination = (e, shownResults) => {
        const cachedQuery = CACHE[bfiQuery];
        // Don't make another request if:
        // - the cached results exceed the shown results
        // - we've already fetched all possible results
        if (cachedQuery.options.length > shownResults || cachedQuery.options.length === cachedQuery.total_count) {
            return;
        }

        set_isLoading(true);
        const page = cachedQuery.page + 1;
        searchBfiNumbers(loanTypeId, bfiQuery, page).then((resp) => {
            const options = cachedQuery.options.concat(resp.result);
            CACHE[bfiQuery] = { ...cachedQuery, options, page };
            set_isLoading(false);
            set_results(options);
        });
    };

    const selectBfiNumber = async (bfiNumber) => {
        if (searchText !== '') {
            set_searchText('');
        }
        onSelect && onSelect(bfiNumber);
    };

    return (
        <AsyncTypeahead
            className='type-ahead'
            id='bfi-search'
            isLoading={isLoading}
            labelKey={(option) => `${option.key}`}
            maxResults={PER_PAGE - 1}
            minLength={2}
            onInputChange={handleBfiInputChange}
            onPaginate={handleBfiPagination}
            onSearch={handleBfiSearch}
            onChange={(event) => selectBfiNumber(event[0]?.key)}
            options={results}
            paginate
            placeholder='BFI or Loan Number...'
            renderMenuItemChildren={(option) => (
                <div
                    key={option.key}
                    style={styles.searchResult}
                >
                    {option.key} {option.name ? ' - ' + option.name : ''}
                </div>
            )}
            useCache={false}
            option
        />
    );
};
